import { EditorView } from '@codemirror/view';
import { DEFAULT_OBJECT_VALUE, DEFAULT_ARRAY_VALUE } from './json-editor';

const jsonCursor = () => {
  let isCursorSet = false;

  return EditorView.updateListener.of((update) => {
    if (isCursorSet) {
      return;
    }

    const value = update.view.state.doc.toString();

    if (value === DEFAULT_OBJECT_VALUE || value === DEFAULT_ARRAY_VALUE) {
      isCursorSet = true;
      setTimeout(() => {
        const pos = 4; // Position after "{\n  " (inside braces)
        update.view.dispatch({
          selection: { anchor: pos, head: pos },
        });
      }, 10);
    }
  });
};

export default jsonCursor;
